// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d0e108d7","921":"1d85d367"}[chunkId] + ".chunk.js";
};